<template>
  <common-dialog ref="dialog" :title="title" width="1000px" @closed="onClosed">
    <el-table size="mini" :data="data" stripe border>
      <el-table-column prop="PhoneCode" label="话机编号"/>
      <el-table-column prop="PhoneNo" label="话机号码" min-width="110"/>
      <el-table-column prop="Place" label="地点" min-width="150" />
      <el-table-column prop="UpperLimit" label="通话时长上限(分钟)" min-width="130" />
      <el-table-column prop="LocationType" label="位置类型" width="90" align="center"/>
      <el-table-column label="启用状态" width="90" align="center">
        <template slot-scope="{row}">
          <el-tag type="success" v-if="row.Status==1">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="连接状态" width="90" align="center">
        <template slot-scope="{row}">
          <el-tag type="success" v-if="row.ConnectStatus==1">正常</el-tag>
          <el-tag type="danger" v-else>异常</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button size="mini" type="primary" @click="onExport">导 出</el-button>
      <el-button size="mini" @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import detailsDialogMixin from "@/mixins/detailsDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [detailsDialogMixin],
  components: { commonDialog },
  data() {
    return {
      api: require("@/api/consume/phonemanage").default,
      data: [],
      params: {},
      title: "导出 话机信息",
    };
  },
  methods: {
    getData(params) {
      this.params = params;
      this.$refs.dialog.isLoading = true;
      this.api.list(params).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) this.data = res.Data;
      });
    },
    onExport() {
      this.api.export(this.params);
    },
    onClosed() {
      this.data = [];
      this.params = {};
    },
  },
};
</script>